import { Box, Typography } from "@mui/material";

/**
 * OAuth error_description from SSO when the user tries a different IdP than their first login.
 */
export function isUserAlreadyExistsAuthConflict(errorDescription) {
  const d = (errorDescription || "").trim().toLowerCase();
  return d.includes("user already exists");
}

/**
 * auth_method query value is a human label, e.g. "Login using Google".
 */
export function getOriginalSignInLabel(authMethod) {
  const raw = (authMethod || "").trim();
  if (!raw) return null;
  const lower = raw.toLowerCase();
  if (lower.includes("google")) return "Google";
  if (lower.includes("apple")) return "Apple";
  return raw;
}

export default function AuthMethodConflictMessage({ authMethod }) {
  const label = getOriginalSignInLabel(authMethod);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        maxWidth: 520,
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: 22, sm: 26 },
          fontWeight: "bold",
          color: "primary.remove",
          mb: 1.5,
        }}
      >
        Use your original sign-in method
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: 16, sm: 18 },
          color: "text.secondary",
          lineHeight: 1.5,
        }}
      >
        This account already exists. You first signed in with{" "}
        <Box component="span" sx={{ fontWeight: 600, color: "text.primary" }}>
          {label}
        </Box>
        . Please go back and sign in using that option instead.
      </Typography>
    </Box>
  );
}
